<template>
  <div id="changeTelphont">
    <div class="steps">
      <el-steps align-center :active="active" >
        <el-step title="验证身份信息"></el-step>
        <el-step title="绑定新手机"></el-step>
        <el-step title="换绑成功"></el-step>
      </el-steps>
    </div>
    <div class="step1" v-if="active === 0">
      <el-form :model="verifyForm" :rules="verifyRules" ref="verifyForm" label-width="134px" class="demo-ruleForm phone-change-form">
        <el-form-item label="已绑定手机号："  prop="telphone">
          <div class="personal_info">
            {{this.verifyForm.telphone}}
          </div>
        </el-form-item>
        <el-form-item label="短信验证码：" prop="sms" class="v_code">
          <el-input placeholder="请输入验证码" v-model="verifyForm.sms" class="v_code_input"></el-input>
          <div v-if="smsCode" class="v_code_btn" @click="sentVCode(verifyForm.telphone)">获取</div>
          <div v-else class="v_code_btn smsFalse">{{ smsTime }}s</div>
        </el-form-item>
      </el-form>
      <div class="step1Btn" @click="step1Next('verifyForm')">
        <div>下一步</div>
      </div>
    </div>
    <div class="step2" v-if="active === 1">
      <el-form :model="newForm" :rules="newRules" ref="newForm" label-width="134px" class="demo-ruleForm phone-change-form">
        <el-form-item label="换绑手机号码：" prop="telphone">
          <el-input placeholder="请输入修改后的手机号" v-model="newForm.telphone"></el-input>
        </el-form-item>
        <el-form-item label="短信验证码：" prop="sms" class="v_code">
          <el-input placeholder="请输入验证码" v-model="newForm.sms" class="v_code_input"></el-input>
          <div v-if="smsCode" class="v_code_btn" @click="sentVCode(newForm.telphone)">获取</div>
          <div v-else class="v_code_btn smsFalse">{{ smsTime }}s</div>
        </el-form-item>
      </el-form>
      <div class="step2Btn" @click="step2Next('newForm')">
        <div>确认换绑</div>
      </div>
    </div>
    <div class="step3" v-if="active === 2">
      <div class="success-result">
        <i class="el-icon-success"></i>
        <div class="success-title">恭喜您！手机号换绑成功～</div>
      </div>
      <router-link tag="div" :to="{name:'BasicInfo'}" class="step3Btn" >
        <div>返回</div>
      </router-link>
    </div>
  </div>
</template>
<script>

import {apiSmsSend,apiSmsCheck,apiChangePhone} from "@/request/API";

export default {
  name: 'changeTelphont',
  props: {
  },
  components: {

  },
  data () {
    return {
      active: 0,
      verifyForm:{
        telphone:this.$store.state.userData.telphone,
        sms:''
      },
      verifyRules: {
        sms: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      newForm:{
        telphone:'',
        sms:''
      },
      newRules: {
        telphone:[
          { required: true, message: '请输入修改后的手机号', trigger: 'blur' },
          { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        sms: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      //获取验证码
      smsCode:true,
      smsTime:60
    }
  },
  methods: {
    /**
     * 验证身份信息 提交按钮
     * @param formName
     */
    step1Next(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid){
          apiSmsCheck({
            phone:this.verifyForm.telphone,
            smsCode:this.verifyForm.sms
          }).then(res=>{
            this.smsCode = true
            if (this.active++ >= 2) this.active = 0;
          }).catch(err=>{
            this.$message({
              type:'error',
              center:true,
              message:err.msg
            })
          })
        }else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    /**
     * 绑定新手机 提交按钮
     * @param formName
     */
    step2Next(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid){
          apiChangePhone({
            phone:this.newForm.telphone,
            smsCode:this.newForm.sms
          }).then(res=>{
            this.$store.commit('set_telphone',this.newForm.telphone)
            this.smsCode = true
            if (this.active++ >= 2) this.active = 0;
          }).catch(err=>{
            this.$message({
              type:'error',
              center:true,
              message:err.msg
            })
          })
        }else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    sentVCode(phone){
      if (this.$store.state.userData.country_code !== '86') {
        this.$message({
          type:'error',
          center:true,
          message:'国际用户暂不支持换绑手机号'
        })
        return
      }
      apiSmsSend({
        phone:phone,
        codeType:3,
        country_code:this.$store.state.userData.country_code
      }).then(res=>{
        this.$message({
          type:'success',
          center:true,
          message:"发送成功"
        })
        this.smsCode = false
      }).catch(err=>{
        this.$message({
          type:"error",
          center:true,
          message:err.msg
        })
      })
    },
    //获取验证码冷却
    countdownTime(){
      this.smsTime--
      if(this.smsTime === 0){
        this.smsCode = true
      }
    }
  },
  mounted () {

  },
  watch: {
    smsCode(val, oldVal){//普通的watch监听
      if(!val){
        this.smsTime = 60
        this.countdown = setInterval(this.countdownTime, 1000);
      }else{
        clearInterval(this.countdown)
      }
    },
  },
  computed: {
  },
  created() {
    if (localStorage.getItem('loginStatus') == "true") {
      this.verifyForm.telphone = JSON.parse(localStorage.getItem('userData')).telphone
    }
  }
}
</script>
<style lang='less' scoped>
#changeTelphont{
  width: 100%;
  min-height: 520px;
  padding: 32px 44px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .steps{
    width: 450px;
    height: 102px;

    /deep/.el-step__line-inner{
      display: none !important;
    }

    /deep/.el-step__line{
      left: 0%;
      right: 0%;
      height: 2px;
      background: var(--border-soft, #E8E4DE);
    }

    /deep/.is-finish > .el-step__line,
    /deep/.is-process > .el-step__line{
      top: 10px;
      height: 4px;
      background: var(--primary, #FF5A1F);
    }

    /deep/.is-wait > .el-step__line{
      display: block;
    }

    /deep/.is-process > .el-step__line{
      display: block;
    }

    /deep/.el-step__icon{
      width: 30px;
      height: 30px;
      line-height: 30px;
      border: none;
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-secondary, #5A5F6B);
      font-size: 18px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
    }

    /deep/.is-finish > .el-step__icon,
    /deep/.is-process > .el-step__icon{
      background: var(--primary, #FF5A1F);
      color: #FFFFFF;
      box-shadow: none;
    }

    /deep/.el-step__title{
      margin: 10px 0 0 0;
      font-size: 16px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 22px;
    }

    /deep/.is-finish .el-step__title,
    /deep/.is-process .el-step__title{
      color: var(--text-main, #111827);
      font-weight: 500;
    }
  }

  .step1,
  .step2,
  .step3{
    width: 560px;
    max-width: 100%;
  }

  .phone-change-form{
    display: table;
    width: auto;
    max-width: 100%;
    margin: 0 auto;
  }

  /deep/.el-form-item{
    min-height: 40px;
    margin-bottom: 22px;
  }

  /deep/.el-form-item__label{
    padding: 0 16px 0 0;
    text-align: right;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 40px;
  }

  /deep/.el-form-item__content{
    min-height: 40px;
    line-height: 40px;
  }

  /deep/.el-input{
    width: 360px;
    max-width: 100%;
  }

  /deep/.el-input__inner{
    width: 100%;
    height: 40px;
    padding: 0 14px;
    background: var(--bg-tag, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
  }

  /deep/.el-input__inner:hover{
    border-color: var(--border-strong, #D8D2CA);
    background: #FFFFFF;
  }

  /deep/.el-input__inner:focus{
    border-color: var(--primary, #FF5A1F);
    background: #FFFFFF;
    box-shadow: none;
  }

  /deep/.is-error .el-input__inner{
    border-color: var(--danger, #EF4444);
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
  }

  /deep/.el-form-item__error{
    padding-top: 5px;
    color: var(--danger, #EF4444);
  }

  .personal_info{
    display: flex;
    width: 360px;
    max-width: 100%;
    min-height: 40px;
    align-items: center;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
  }

  .v_code /deep/.el-form-item__content{
    display: flex;
    align-items: flex-start;
  }

  .v_code_input,
  .v_code_input /deep/.el-input__inner{
    width: 246px;
  }

  .v_code_btn{
    margin: 0 0 0 10px !important;
    width: 104px;
    height: 40px;
    border: 1.5px solid var(--bg-dark, #1A1D24);
    border-radius: 3px;
    background: #FFFFFF;
    color: var(--text-main, #1A1D24);
    cursor: pointer;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 500;
    line-height: 38px;
    transition: color .2s ease, background .2s ease, border-color .2s ease;
  }

  .v_code_btn:hover{
    border-color: var(--bg-dark, #1A1D24);
    background: var(--bg-tag, #F0EDE8);
  }

  .smsFalse{
    color: var(--text-muted, #9AA0AC);
    border-color: var(--border-soft, #E8E4DE);
    background: var(--bg-tag, #F0EDE8);
    cursor: auto;
  }

  .smsFalse:hover{
    border-color: var(--border-soft, #E8E4DE);
    background: var(--bg-tag, #F0EDE8);
  }

  .step1Btn,
  .step2Btn,
  .step3Btn{
    width: 560px;
    max-width: 100%;
    margin: 8px auto 0;
    padding-left: 0;
    display: flex;
    justify-content: center;

    div{
      width: 200px;
      height: 42px;
      border-radius: 3px;
      background: var(--primary, #FF5A1F);
      box-shadow: none;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 42px;
      text-align: center;
      cursor: pointer;
      transition: background .2s ease;
    }

    div:hover{
      background: var(--primary-hover, #E84A12);
    }
  }

  .step3{
    padding-top: 4px;

    .success-result{
      width: 100%;
      min-height: 198px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: var(--text-main, #111827);
    }

    .el-icon-success{
      width: 72px;
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: var(--success-soft, #ECFDF5);
      color: var(--success, #22C55E);
      font-size: 42px;
      box-shadow: 0 10px 22px rgba(34, 197, 94, 0.14);
    }

    .success-title{
      margin-top: 18px;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      line-height: 28px;
      text-align: center;
    }

    .step3Btn{
      width: 560px;
      justify-content: center;
      padding-left: 0;
      margin-top: 22px;
    }
  }
}
</style>
